// extracted by mini-css-extract-plugin
export default {"container":"WarehouseHistory_container__U6qo1","header":"WarehouseHistory_header__GTwI8"};